module.exports = __webpack_public_path__ + "img/A@2x.30300237.jpg";